var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { baseApi } from "@madmedical/store";
const api = baseApi
    .enhanceEndpoints({
    addTagTypes: [
        "insulin-administrations",
        "insulin-protocols",
        "insulin-reminders",
    ],
})
    .injectEndpoints({
    endpoints: (build) => ({
        getInsulinProducts: build.query({
            query: () => ({
                url: `medical/insulin-products`,
            }),
        }),
        getInsulinAdministrations: build.query({
            query: (_a) => {
                var { patientId } = _a, params = __rest(_a, ["patientId"]);
                return ({
                    url: `medical/patients/${patientId}/insulin-administrations`,
                    params,
                });
            },
            serializeQueryArgs: ({ queryArgs }) => {
                const { page, pageSize } = queryArgs, args = __rest(queryArgs, ["page", "pageSize"]);
                return args;
            },
            merge: (cachedData, responseData) => {
                if (responseData.pagination.currentPage === 1) {
                    // Reset to first page
                    return responseData;
                }
                cachedData.items.push(...responseData.items);
                cachedData.pagination = responseData.pagination;
            },
            forceRefetch: ({ currentArg, previousArg }) => !currentArg ||
                !previousArg ||
                currentArg.page !== previousArg.page ||
                currentArg.pageSize !== previousArg.pageSize,
            providesTags: ["insulin-administrations"],
        }),
        getInsulinAdministrationRange: build.query({
            query: (_a) => {
                var { patientId } = _a, params = __rest(_a, ["patientId"]);
                return ({
                    url: `medical/patients/${patientId}/insulin-administrations/range`,
                    params: Object.assign({}, params),
                });
            },
            providesTags: ["insulin-administrations"],
        }),
        createInsulinAdministration: build.mutation({
            query: (_a) => {
                var { patientId } = _a, body = __rest(_a, ["patientId"]);
                return ({
                    url: `medical/patients/${patientId}/insulin-administrations`,
                    method: "POST",
                    body,
                });
            },
            invalidatesTags: ["insulin-administrations"],
        }),
        updateInsulinAdministration: build.mutation({
            query: (_a) => {
                var { id } = _a, body = __rest(_a, ["id"]);
                return ({
                    url: `medical/insulin-administrations/${id}`,
                    method: "PATCH",
                    body,
                });
            },
            invalidatesTags: ["insulin-administrations"],
        }),
        deleteInsulinAdministration: build.mutation({
            query: (id) => ({
                url: `medical/insulin-administrations/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["insulin-administrations"],
        }),
        getInsulinProtocols: build.query({
            query: () => ({
                url: `medical/insulin-protocols`,
            }),
            providesTags: ["insulin-protocols"],
        }),
        updateInsulinProtocol: build.mutation({
            query: (_a) => {
                var { patientId } = _a, body = __rest(_a, ["patientId"]);
                return ({
                    url: `medical/patients/${patientId}/insulin-protocols`,
                    method: "PUT",
                    body,
                });
            },
            invalidatesTags: ["insulin-protocols"],
        }),
        getInsulinProcolByPatient: build.query({
            query: ({ patientId }) => ({
                url: `medical/patients/${patientId}/insulin-protocols`,
            }),
        }),
        getInsulinReminders: build.query({
            query: ({ patientId }) => ({
                url: `medical/patients/${patientId}/insulin-reminders`,
            }),
            providesTags: ["insulin-reminders"],
        }),
        createInsulinReminder: build.mutation({
            query: (_a) => {
                var { patientId } = _a, body = __rest(_a, ["patientId"]);
                return ({
                    url: `medical/patients/${patientId}/insulin-reminders`,
                    method: "POST",
                    body,
                });
            },
            invalidatesTags: ["insulin-reminders"],
        }),
        updateInsulinReminder: build.mutation({
            query: (_a) => {
                var { insulinReminderId } = _a, body = __rest(_a, ["insulinReminderId"]);
                return ({
                    url: `medical/insulin-reminders/${insulinReminderId}`,
                    method: "PATCH",
                    body,
                });
            },
            invalidatesTags: ["insulin-reminders"],
        }),
        deleteInsulinReminder: build.mutation({
            query: (id) => ({
                url: `medical/patients/insulin-reminders/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["insulin-reminders"],
        }),
    }),
});
export const { useGetInsulinProductsQuery, useGetInsulinAdministrationsQuery, useGetInsulinAdministrationRangeQuery, useCreateInsulinAdministrationMutation, useUpdateInsulinAdministrationMutation, useDeleteInsulinAdministrationMutation, useGetInsulinProtocolsQuery, useUpdateInsulinProtocolMutation, useGetInsulinProcolByPatientQuery, useGetInsulinRemindersQuery, useCreateInsulinReminderMutation, useUpdateInsulinReminderMutation, useDeleteInsulinReminderMutation, } = api;
